export const logos = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  height: "24px",
  margin: "0",
  fill: "grey7",
  color: "grey7",
};

export const appLogo = {
  height: "100%",
};

export const seperator = {
  fill: "grey7",
  margin: "0 10px",
};

export const productLogo = {
  height: "100%",
  maxHeight: "16px",
  fill: "grey7",

  "*": {
    width: "auto",
  },
};

export const variantLogo = {
  height: "100%",
  maxHeight: "19px",
  fill: "grey7",
};
